import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { Tag } from '@app/app/_components/Tag/Tag';
import { HomeInsuranceRiskPackage } from '@app/domain/model/eshop/home/HomeInsuranceRiskPackage';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { SplitNumberResult } from '@app/lib/split-number/splitNumber';
import { useTranslations } from 'next-intl';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';

interface Props {
    risk: HomeInsuranceRiskPackage;
    splittedPrice: SplitNumberResult;
    hasDiscount: boolean;
    discountPercentage: number;
}

export function InsuranceRisksLabel({ risk, splittedPrice, hasDiscount, discountPercentage }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();

    return (
        <div className="flex flex-col gap-3 md:flex-row md:items-start md:gap-4">
            <div className="flex flex-1 flex-col gap-3">
                <div className="flex flex-wrap items-center gap-3">
                    <Heading level="h4">{risk.name}</Heading>
                    {hasDiscount && (
                        <Tag variant="promo">
                            {t('eshop.transport.save')} {discountPercentage.toFixed(0)}%
                        </Tag>
                    )}
                </div>

                <div className="flex flex-col gap-1">
                    {hasDiscount && risk.premium && (
                        <Paragraph isGray size="tiny" className="line-through">
                            {formatEuroValue(risk.premium, tenant)}
                        </Paragraph>
                    )}
                    <div className="flex items-baseline gap-1">
                        <Paragraph isBold size="medium">
                            {splittedPrice.integerPart}
                        </Paragraph>
                        <Paragraph isBold size="tiny" className="self-start">
                            {splittedPrice.fractionalPart}
                        </Paragraph>
                        <Paragraph isBold size="medium">
                            €
                        </Paragraph>
                        <Paragraph isGray className="ml-1">
                            {`/ ${t.rich('eshop.home.months', {
                                count: 12,
                            })}`}
                        </Paragraph>
                    </div>
                </div>
            </div>
        </div>
    );
}
